import React from 'react'
import leftarrow from "../../../assets/images/left-arrow.svg";
import styles from './forgotPassword.module.css';
import { Footer } from '../../common/footer/footer';
import { useTranslation } from "react-i18next";
import login1json from "./forgotPassword.json";
import env from "../../../assets/Instituteppvimages/mail-pencil.svg"

const ForgotPassJsx = (props) => {
  const { t } = useTranslation();
  const {
    onInputChangeHandler,
    onTouchHandler,
    formSubmitButtonDisable,
    formError,
    formSubmitHandler,
    isLoading
  } = props;
  const flowType = localStorage.getItem("flowType");

  // Function to get placeholder text based on flowType
  const getPlaceholder = () => {
    switch (flowType) {
      case "customer":
        return "Enter Customer Email*";
      case "expert":
        return "Enter Expert Email*";
      case "institute":
        return "Enter Institute Email*";
      default:
        return "Enter Email*";
    }
  };

  // Function to get input class based on flowType
  const getInputClass = (item) => {
    let baseClass = item.isRequired && formError[item.name]
      ? "input form-control is-invalid"
      : "input form-control";

    // Add flowType-specific class only for email input
    if (item.name === 'email' && flowType) {
      baseClass += ` email-input-${flowType}`;
    }

    return baseClass;
  };

  return (
    <>
      <section className="mainloginscreen">
        <div className="container">
          <div className={`${styles.mainloginscreeninner}`}>
            <div className={`${styles.leftsightbackdetails} d-flex`}>
              <div className="d-flex plaindetailsleft align-items-center justify-content-center">
                <div className="back_btn" onClick={() => props.onBackClick()}><img src={leftarrow} alt={'icon'} /></div>
                <h1>{t("PASSWORDAUTHORIZATION.Email_Enter_Heading")}</h1>
              </div>
            </div>
          </div>
          <div className={`${styles.formsection}`}>
            <div className={`${styles.institutelogintext}`}>
              <div className="forgetpassinner">
                <h2 className="h2_style text-center">{t("PASSWORDAUTHORIZATION.Email_Enter_Headingno")}</h2>
                <h5 className="text-center mt-2">{t("PASSWORDAUTHORIZATION.Receive_OTP")}</h5>

                <div className={`${styles.ft_inner} otpauthentication`}>
                  <h5 className={`${styles.small} text-left`}>{t("PASSWORDAUTHORIZATION.Email_Enter")}</h5>

                  {login1json.map((item, i) => (
                    <React.Fragment key={i}>
                      {item.fieldType === "input" &&
                        <div className={`input-container form-group ${styles.formfield}`}>
                          <input
                            onChange={onInputChangeHandler}
                            onBlur={onTouchHandler}
                            required
                            type={item.type}
                            placeholder={getPlaceholder()}
                            className={getInputClass(item)}
                            id={item.name}
                            name={item.name}
                          />
                          <span className={`${styles.form_image} form_imageglobal imageglobal-${flowType}`}><img src={env} alt={'formimage'} /></span>
                          <span className="text-danger">
                            {item.isRequired &&
                              formError[item.name] &&
                              (formError[item.name] === "req"
                                ? t(item.error)
                                : t(item.type_error))}
                          </span>
                        </div>
                      }
                    </React.Fragment>
                  ))}
                  <div className="d-flex align-items-center justify-content-center">
                    <button
                      disabled={formSubmitButtonDisable}
                      onClick={formSubmitHandler}
                      type="button"
                      className={
                        formSubmitButtonDisable
                          ? "mt-3 mainbutton"
                          : "mt-3 mainbutton"
                      }
                    >
                      {isLoading ? t("COMMON.PROCESSING") : t("COMMON.CONTINUE")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </section>
    </>
  );
};

export default ForgotPassJsx;